"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonConfigProvider = void 0;
function jsonConfigProvider(initialJsonObj = {}, flattenObj = true) {
    const configs = new Map();
    function flattenParams(obj, prefix = []) {
        if (typeof obj === 'object' && obj !== null) {
            Object.entries(obj).forEach(([key, value]) => flattenParams(value, prefix.concat(key)));
        }
        else {
            configs.set(prefix.join('.'), String(obj));
        }
    }
    function parseConfigs(jsonObj = initialJsonObj) {
        configs.clear();
        if (flattenObj) {
            flattenParams(jsonObj);
        }
        else {
            Object.entries(jsonObj).forEach(([key, value]) => configs.set(key, String(value)));
        }
    }
    parseConfigs();
    return {
        load() {
            // noop
        },
        get(key) {
            return configs.get(key);
        },
        getAll() {
            return configs;
        },
        has(key) {
            return configs.has(key);
        },
        update(newJsonObj) {
            parseConfigs(newJsonObj);
        },
    };
}
exports.jsonConfigProvider = jsonConfigProvider;
//# sourceMappingURL=json.js.map